import { ModalRef, useEntityMetadata, useFormBaseMetadata, useModuleFederationContext } from '@msdk/common'
import { Entity, EntityMetadata, EntityModel, FormMode, GenericFieldValue } from '@msdk/definitions'
import React from 'react'

import { resolveItem } from '../../utils'
import { ImportedComponentErrorBoundary } from '../ImportedComponentBoundary'
import { ModalFormDynamic } from './ModalFormDynamic'

interface Props {
  entityName: string
  formName: string
  id: string
  mode: FormMode
  modalRef?: ModalRef
  prefilledFields?: Record<string, GenericFieldValue>
  containerEntity?: Entity
}

export function ModalForm(props: Props) {
  const model = useEntityMetadata(props.entityName) as EntityModel
  const formModel = model.getForm(props.formName)
  const baseMetadata = useFormBaseMetadata(props.entityName, props.formName) as EntityMetadata
  const modules = useModuleFederationContext()
  const msModule = modules.loadedModules[baseMetadata.msProvider]
  const ImportedComponent = resolveItem(msModule, formModel?.componentDefinition?.fullName)

  return (
    <>
      {ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <ImportedComponent />
        </ImportedComponentErrorBoundary>
      )}
      {!ImportedComponent && <ModalFormDynamic {...props} />}
    </>
  )
}
